export default {
      id: "building-white-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.e22fd14f.svg#building-white",
      toString: function () {
        return this.url;
      }
    }